import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { masterApi, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const token = params.get("token");

  const submit = async () => {
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    try {
      await masterApi.post("/auth/reset-password", { token, password: pw });
      toast.success("Password reset. Please log in.");
      navigate("/auth");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-5">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-3xl p-6 shadow-xl space-y-4">
        <h1 className="text-xl font-extrabold text-slate-900 font-head">Set a new password</h1>
        {!token ? <p className="text-sm text-red-500">Invalid reset link.</p> : (
          <>
            <PasswordInput data-testid="reset-password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-12 bg-slate-50 border-slate-200" />
            <Button data-testid="reset-submit" onClick={submit} className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white font-bold">Reset Password</Button>
          </>
        )}
      </div>
    </div>
  );
}
